// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","853":"component---src-pages-projects-js","989":"component---src-templates-blog-post-js"}[chunkId] + "-" + {"678":"cadfaad534cc18fdb4a8","853":"883930142fbe464134af","989":"7ed721cacbce976694a4"}[chunkId] + ".js";
};